export default "__VITE_PUBLIC_ASSET__1396067e__"